import DevLog from '../../devlog/Module'
import ViewportModule from '../../viewport/Module'
import InteractionsModule from '../../interactions/Module'
import errorAction from '../../../actions/error/errorAction'
import transferActionProps from '../transferActionProps'
import { doPost } from '../doPost'

import { IAction, IActionSubmitResponse, IPVResponse } from '../../../actions/types'
import { ModuleID } from '../../types'
import { ISendResponseBody } from '../types'

import { CLIENT_VERSION, DEBUG_CLIENT } from '../const'
import { getProxyParamsFromUrl, getURLfromAction } from '../lib'
import HooksModule from '@aytm/app/swidget/base/modules/hooks/Module.ts'

export default async function sendResponse(fromAction: IAction, response: IActionSubmitResponse[]) {
  const responseBody: ISendResponseBody = {
    device: ViewportModule.viewport.device,
    mode: fromAction.mode,
    proxy_params: fromAction.action_proxy_params || getProxyParamsFromUrl(fromAction),
    payload: response.map(response => {
      return {
        full_time: response.durations.full_time,
        id: response.id,
        log: response.log,
        response: response.response,
        time: response.durations.time,
        version: CLIENT_VERSION,
        url: getURLfromAction(fromAction),
        ...(response.check_response && { check_response: response.check_response })
      }
    })
  }

  if (DEBUG_CLIENT) {
    DevLog._log(`SW[${ModuleID.CLIENT}]:`, 'sendResponse', responseBody)
  }

  let nextAction = errorAction(fromAction)

  if (fromAction.action_url) {
    try {
      const actionResponse = await doPost<IAction | IPVResponse>(getURLfromAction(fromAction), responseBody).catch(
        error => {
          DevLog.error(error, `SW[${ModuleID.CLIENT}]:`, 'sendResponse')
          return errorAction(fromAction)
        }
      )
      if (!actionResponse) return null
      if (HooksModule.hasInterceptHook && actionResponse.data && (actionResponse as IAction).data.questions) {
        const interception = await HooksModule.doIntercept(actionResponse as IAction)
        if (interception) {
          return null
        }
      }
      nextAction = (actionResponse as IAction).action
        ? (actionResponse as IAction)
        : (actionResponse as IPVResponse).data
      if (!nextAction.mode) {
        nextAction.mode = fromAction.mode
      }

      if (InteractionsModule.enabled) {
        response.forEach(r => {
          if (r.interactions) {
            InteractionsModule.send(String(r.id), r.interactions).catch(() => {})
          }
        })
      }
    } catch (error) {
      DevLog.error(error, `SW[${ModuleID.CLIENT}]:`, 'sendResponse')
    }
  } else {
    DevLog.error(new Error('no action_url in action'), `SW[${ModuleID.CLIENT}]:`, 'sendResponse', fromAction)
  }

  return transferActionProps(fromAction, nextAction)
}
